module.exports = __webpack_public_path__ + "static/media/delivery.9ec4f087.svg";